export default "__VITE_ASSET__4b58e6e0__"